import React from 'react';
import { CmhcIcon, CmhcIconSize, FormField } from '@cmhc-schl/hearth-ui';
import styles from './styles.module.scss';
import { InputFieldComponentProps } from './types';

const InputField = ({
  id,
  label,
  ariaText,
  ariaDescription,
  value,
  placeholder,
  error,
  onBlur,
  onChange,
  hideClearIcon = true,
  leadingIcon,
  errorStatus,
  inputRef
}: InputFieldComponentProps) => {
  return (
    <>
      {label && (
        <label key={id} htmlFor={id!} className={styles.inputLabel}>
          {label}
        </label>
      )}
      <FormField
        id={id}
        fullWidth
        inputRef={inputRef}
        ariaText={ariaText?.value}
        ariaDescription={ariaDescription}
        placeholder={placeholder}
        value={value}
        status={error || errorStatus ? 'error' : 'success'}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => onBlur?.(value)}
        hideClearIcon={hideClearIcon}
        leadingIcon={leadingIcon}
        data-testid={`${ariaText?.value}-input-field-component`}
      />
      {error && (
        <div className={styles.fieldErrorContainer}>
          <CmhcIcon
            size={CmhcIconSize.SMALL}
            type="icon_info_outlined"
            className={styles.errorInfoIcon}
          />
          <span role="alert" className={styles.errorMessageText}>
            {error}
          </span>
        </div>
      )}
    </>
  );
};

export default InputField;
